module.exports = __webpack_public_path__ + "img/temp-home-01.70979d0e.jpg";